import { type HTMLAttributes } from 'react'
import { cx } from '#app/utils/cx.ts'

export const SpacebrainsLogo = (props: HTMLAttributes<HTMLOrSVGElement>) => {
	return (
		<svg
			{...props}
			viewBox="0 0 463 80"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={cx('h-6 w-auto shrink-0', props.className)}
		>
			<path
				d="M39.9968 0L27.8359 7.53666L39.9968 15.0733L52.1572 7.53666L39.9968 0Z"
				fill="#004A8F"
			/>
			<path
				d="M52.1642 7.53687V29.2083L65.7416 20.7932C75.2495 14.9005 80.003 16.3795 80.003 25.2306V41.9314C80.003 50.7834 75.2495 58.1555 65.7416 64.0482L40.0033 79.9999V15.0735L52.1642 7.53687ZM52.1642 62.629L65.0197 54.6612C66.9004 53.4956 67.8413 52.0376 67.8413 50.2885V31.9486C67.8413 30.2004 66.9004 29.9088 65.0197 31.0747L52.1642 39.0421V62.629Z"
				fill="#002952"
			/>
			<path
				d="M40.0002 55.985V45.254L15.505 31.0925C13.0437 29.8053 11.8126 30.2369 11.8126 32.3865C11.8126 34.6774 12.9064 36.5247 15.0939 37.9296L35.3095 52.5499C37.0186 53.6628 38.6099 54.8306 40.0002 55.985V79.9999C37.6107 79.4854 6.5067 59.012 6.5067 59.012L0 51.8169V45.4056L27.5611 62.6036C30.0058 63.8815 31.2289 63.4449 31.2289 61.2954C31.2289 59.0892 30.1962 57.3016 28.1336 55.9315L13.8815 46.8967C4.62732 40.8247 0 34.2244 0 27.097C0 18.0038 5.86463 16.5231 17.593 22.6543L40.0002 35.3823V46.4227"
				fill="#003566"
			/>
			<path
				d="M40.0033 35.3948L46.539 32.0649V41.8992L40.0033 45.2518V35.3948Z"
				fill="#004A8F"
			/>
			<path
				d="M40.0033 55.9613C44.319 55.4865 46.4761 58.1372 46.4761 63.9109C46.4761 70.4305 44.319 75.7855 40.0033 79.9759V55.9613Z"
				fill="#004A8F"
			/>
			<path
				d="M94.3396 58.8658V52.9241H112.921C116.084 52.9241 117.666 51.5258 117.666 48.7293C117.666 45.8409 116.379 44.2098 113.805 43.8362L104.555 42.5079C97.7443 41.4833 94.3396 38.2208 94.3396 32.7214C94.3396 25.825 98.4684 22.3752 106.727 22.3752H119.838H123.538V28.317H106.887C103.67 28.317 102.061 29.7153 102.061 32.5114C102.061 35.1224 103.401 36.6362 106.084 37.0553L115.414 38.3836C122.117 39.3623 125.469 42.7179 125.469 48.4501C125.469 55.3947 121.312 58.8658 113.001 58.8658H98.0395H94.3396Z"
				fill="#003566"
			/>
			<path
				d="M129.038 72.8437V22.3713H151.802C160.007 22.3713 164.109 25.937 164.109 33.067V48.0967C164.109 55.2744 160.007 58.8624 151.802 58.8624H136.841V72.8437H129.038ZM136.841 52.9206H151.641C154.751 52.9206 156.306 51.546 156.306 48.7958V32.3679C156.306 29.6659 154.751 28.3136 151.641 28.3136H136.841V52.9206Z"
				fill="#003566"
			/>
			<path
				d="M180.065 58.8624C171.807 58.8624 167.678 55.2971 167.678 48.1667C167.678 41.0366 171.807 37.471 180.065 37.471H193.66V32.3679C193.66 29.6659 192.103 28.3136 188.994 28.3136H171.78V22.3713H175.481H189.155C197.36 22.3713 201.462 25.937 201.462 33.067V58.8624H180.065ZM175.481 48.7958C175.481 51.546 177.062 52.9206 180.227 52.9206H193.66V42.784H180.227C177.062 42.784 175.481 44.1591 175.481 46.9084V48.7958Z"
				fill="#003566"
			/>
			<path
				d="M205.029 48.1006V33.0709C205.029 25.9409 209.131 22.3752 217.336 22.3752H232.86H236.56V28.3174H217.576C214.412 28.3174 212.831 29.6693 212.831 32.3718V48.7997C212.831 51.5499 214.412 52.9245 217.576 52.9245H236.56V58.8663H232.86H217.336C209.131 58.8663 205.029 55.2783 205.029 48.1006Z"
				fill="#003566"
			/>
			<path
				d="M240.12 48.0967V33.067C240.12 25.937 244.222 22.3713 252.427 22.3713H262.884C271.088 22.3713 275.191 25.937 275.191 33.067V43.1336H247.922V48.7958C247.922 51.5464 249.504 52.9206 252.668 52.9206H273.582V58.8624H269.962H252.427C244.222 58.8624 240.12 55.2744 240.12 48.0967ZM247.922 37.821H267.388V32.3679C267.388 29.6659 265.832 28.3136 262.723 28.3136H252.668C249.504 28.3136 247.922 29.6659 247.922 32.3679V37.821Z"
				fill="#003566"
			/>
			<path
				d="M278.762 58.8648V7.13501H286.564V22.3738H301.526C309.73 22.3738 313.833 25.9394 313.833 33.0695V48.0991C313.833 55.2768 309.73 58.8648 301.526 58.8648H278.762ZM286.564 52.923H301.365C304.474 52.923 306.03 51.5484 306.03 48.7982V32.3703C306.03 29.6683 304.474 28.316 301.365 28.316H286.564V52.923Z"
				fill="#003566"
			/>
			<path
				d="M317.402 58.8658V26.7096C319.278 23.8203 322.844 22.3752 328.1 22.3752H336.385H340.085V28.317H329.628C327.537 28.317 326.061 28.7834 325.204 29.7153V58.8658H317.402Z"
				fill="#003566"
			/>
			<path
				d="M356.036 58.8624C347.778 58.8624 343.649 55.2971 343.649 48.1667C343.649 41.0366 347.778 37.471 356.036 37.471H369.63V32.3679C369.63 29.6659 368.074 28.3136 364.965 28.3136H347.751V22.3713H351.451H365.125C373.33 22.3713 377.432 25.937 377.432 33.067V58.8624H356.036ZM351.451 48.7958C351.451 51.546 353.032 52.9206 356.197 52.9206H369.63V42.784H356.197C353.032 42.784 351.451 44.1591 351.451 46.9084V48.7958Z"
				fill="#003566"
			/>
			<rect
				x="381.001"
				y="22.3752"
				width="7.7984"
				height="36.4906"
				fill="#003566"
			/>
			<rect
				x="381.001"
				y="8.45728"
				width="7.7984"
				height="6.9053"
				fill="#003566"
			/>
			<path
				d="M392.366 58.8658V22.3752H415.13C423.334 22.3752 427.436 25.9405 427.436 33.0705V58.8658H419.634V32.3714C419.634 29.6693 418.078 28.317 414.969 28.317H400.168V58.8658H392.366Z"
				fill="#003566"
			/>
			<path
				d="M431.006 58.8658V52.9241H449.587C452.75 52.9241 454.333 51.5258 454.333 48.7293C454.333 45.8409 453.046 44.2098 450.472 43.8362L441.221 42.5079C434.411 41.4833 431.006 38.2208 431.006 32.7214C431.006 25.825 435.135 22.3752 443.394 22.3752H456.505H460.205V28.317H443.554C440.337 28.317 438.728 29.7153 438.728 32.5114C438.728 35.1224 440.068 36.6362 442.75 37.0553L452.08 38.3836C458.783 39.3623 462.135 42.7179 462.135 48.4501C462.135 55.3947 457.979 58.8658 449.667 58.8658H434.706H431.006Z"
				fill="#003566"
			/>
		</svg>
	)
}
